import { render, staticRenderFns } from "./EmbedCaseFile.vue?vue&type=template&id=1c43e188&"
import script from "./EmbedCaseFile.vue?vue&type=script&lang=js&"
export * from "./EmbedCaseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports